// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/delivery_day_band_state.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/delivery_day_band_state.proto.
 */
export const file_bfftypes_v1_delivery_day_band_state: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ0eXBlcy92MS9kZWxpdmVyeV9kYXlfYmFuZF9zdGF0ZS5wcm90bxILYmZmdHlwZXMudjEqqAEKFERlbGl2ZXJ5RGF5QmFuZFN0YXRlEicKI0RFTElWRVJZX0RBWV9CQU5EX1NUQVRFX1VOU1BFQ0lGSUVEEAASIAocREVMSVZFUllfREFZX0JBTkRfU1RBVEVfRlVMTBABEiMKH0RFTElWRVJZX0RBWV9CQU5EX1NUQVRFX1BBUlRJQUwQAhIgChxERUxJVkVSWV9EQVlfQkFORF9TVEFURV9OT05FEANCQlpAZ2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7YmZmdHlwZXN2MWIGcHJvdG8z");

/**
 * DeliveryDayBandState は手入力取引閲覧モーダルの受渡期間カレンダービュー
 * (spec bilateral-trade-manual-detail.md AC-SBM-007) が使う、1 日あたりの
 * 対象コマ規模区分。Mirrors backend types.v1.DeliveryDayBandState 1:1
 * (wire 値も同一)。
 *
 * @generated from enum bfftypes.v1.DeliveryDayBandState
 */
export enum DeliveryDayBandState {
  /**
   * @generated from enum value: DELIVERY_DAY_BAND_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 当該日は 48 コマ全てが対象 (例: ベース時間帯区分の全日、オフピークの休日)。
   *
   * @generated from enum value: DELIVERY_DAY_BAND_STATE_FULL = 1;
   */
  FULL = 1,

  /**
   * 当該日は一部のコマのみが対象 (例: ピーク時間帯区分の非休日、オフピークの非休日)。
   *
   * @generated from enum value: DELIVERY_DAY_BAND_STATE_PARTIAL = 2;
   */
  PARTIAL = 2,

  /**
   * 当該日は対象コマなし (例: ピーク時間帯区分の休日、受渡カレンダー例外による対象外化)。
   *
   * @generated from enum value: DELIVERY_DAY_BAND_STATE_NONE = 3;
   */
  NONE = 3,
}

/**
 * Describes the enum bfftypes.v1.DeliveryDayBandState.
 */
export const DeliveryDayBandStateSchema: GenEnum<DeliveryDayBandState> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_delivery_day_band_state, 0);

